<template>
    <div class="health-record-manage-container">
        <van-notice-bar left-icon="info-o"
            >已添加档案（{{ healthRecordList.length }}/5）</van-notice-bar
        >
        <van-cell-group>
            <template v-for="(item, index) in healthRecordList">
                <van-swipe-cell :key="index">
                    <van-card class="health-record-card" centered @click="editHealth(item)">
                        <template #title>
                            <div class="title">{{ item.name }}</div>
                        </template>
                        <template #desc>
                            <div class="desc">{{ item.idCard }}</div>
                        </template>
                        <template #tags v-if="item.isDefault">
                            <van-tag type="success">默认</van-tag>
                        </template>
                    </van-card>

                    <template #right>
                       <!-- <van-button
                            v-if="!item.isDefault"
                            square
                            text="默认"
                            type="info"
                            class="edit-button"
                            @click="defaultHandle(item)"
                        /> -->
                        <!-- <van-button square text="修改" type="primary" class="edit-button" /> -->
                        <van-button
                            @click="removeHandle(item)"
                            square
                            text="删除"
                            type="danger"
                            class="delete-button"
                        />
                    </template>
                </van-swipe-cell>
            </template>
        </van-cell-group>
        <div class="tools">
            <van-button
                round
                block
                size="small"
                type="primary"
                @click="addHandle"
                >添加档案</van-button
            >
        </div>
    </div>
</template>

<script>
import manageApi from '@/api/manageApi';

export default {
    data() {
        return {
            healthRecordList: []
        }
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            manageApi.queryHealthRecord().then(res => {
                this.healthRecordList = res.data;
            }).catch(() => {

            });
        },
        defaultHandle(item) {
            const { $dialog, $toast } = this;

            $dialog.confirm({
                message: '确定切换默认健康档案?',
                beforeClose: (action, done) => {
                    if (action === 'confirm') {
                        manageApi.changeHealthRecordDefault(item.id).then(res => {
                            $toast('切换成功');
                            this.healthRecordList = [];
                            this.$nextTick(() => {
                                this.healthRecordList = res.data;
                            });
                            done();
                        }).catch(() => {

                        });
                    } else {
                        done();
                    }
                }
            });
        },
        addHandle() {
            const { $router, $toast, healthRecordList } = this;
            if (5 <= healthRecordList.length) {
                $toast('最多只能添加5份健康档案');
                return;
            }
            $router.push({
                path: '/manage/health_record'
            });
        },
        editHealth(item) {
            const { $router } = this;
            $router.push({
                path: '/manage/health_record',
                query: {
                    id: item.id
                }
            });
        },
        removeHandle(item) {
            const { $dialog, $toast } = this;

            $dialog.confirm({
                message: '确定删除该份健康档案?',
                beforeClose: (action, done) => {
                    if (action === 'confirm') {
                        manageApi.removeHealthRecord(item.id).then(res => {
                            $toast('删除成功');
                            this.healthRecordList = [];
                            this.$nextTick(() => {
                                this.healthRecordList = res.data;
                            });
                            done();
                        }).catch(() => {

                        });
                    } else {
                        done();
                    }
                }
            });
        }
    },
}
</script>

<style lang="less" scoped>
.health-record-manage-container {
    margin-bottom: 1.333333rem;
}

.border-bottom {
    content: " ";
    position: absolute;
    left: 0;
    right: 0;
    height: 0.026667rem;
    color: @border-color;
    bottom: 0;
    border-bottom: 0.026667rem solid @border-color;
    transform-origin: 0 100%;
    transform: scaleY(0.5);
}

.health-record-card:after {
    .border-bottom;
}

.health-record-card .title {
    font-size: 0.426667rem;
    color: @black-color;
}

.health-record-card .desc {
    font-size: 0.373333rem;
    margin: 0.133333rem 0;
}

.health-record-card {
    color: @grey-color;
    margin: 0;
    background-color: @white-color;
}

.edit-button,
.delete-button {
    height: 100%;
}

.tools {
    position: fixed;
    bottom: 0;
    padding: 0.213333rem 0.48rem;
    background-color: @white-color;
    left: 0;
    right: 0;
    height: 0.933333rem;
    box-shadow: 0 -0.06rem 0.1rem 0.04rem rgba(0, 0, 0, 0.03);
    display: flex;
    align-items: center;
}
</style>